const byId = (items) =>
  items.reduce((result, item) => {
    result[item.id] = item; // eslint-disable-line no-param-reassign
    return result;
  }, {});

export default (from, to) => {
  const result = { items: [], states: {}, changed: false };
  const length = Math.max(from.length, to.length);
  const fromById = byId(from);
  const toById = byId(to);
  let i = -1;

  // eslint-disable-next-line no-plusplus
  while (++i < length) {
    const fromItem = from[i];
    const toItem = to[i];

    // when the old list has an item at the current index
    // and the new list doesn't have that item flag it as 'remove'
    if (fromItem && !toById[fromItem.id]) {
      result.items.push(fromItem);
      result.states[fromItem.id] = 'remove';
      result.changed = true;
    }

    // when the new list has an item at the current index
    if (toItem) {
      result.items.push(toItem);

      if (!fromById[toItem.id]) {
        result.states[toItem.id] = 'add';
        result.changed = true;
      }
    }
  }

  return result;
};
